import { Link } from '@paypalcorp/pp-react-links';
import { Sheet } from '@paypalcorp/pp-react-modal';
import { BodyText, HeadingText } from '@paypalcorp/pp-react-text';
import { Container, Row, Col } from '@paypalcorp/pp-react-grid';
import { Button } from '@paypalcorp/pp-react-buttons';
import { Card } from '@paypalcorp/pp-react-card';
import { PlayIcon, DocumentIcon } from '@paypalcorp/pp-react-icons';
import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { PAYPAL_THEME } from '@paypalcorp/pp-react-theme';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import '../__generated__/styles/IPSCards.css';
import React, { useState, useEffect } from 'react';
import _typeof from '@babel/runtime/helpers/esm/typeof';
import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _inherits from '@babel/runtime/helpers/esm/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/esm/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/esm/getPrototypeOf';
import PropTypes from 'prop-types';
import _startsWith from 'lodash/startsWith';
import { ThemeProvider } from '@emotion/react';

/**
 *  method to validate is empty.
 * @param value
 * @returns {boolean}
 */
var isEmpty = function (value) {
  return value === null || _typeof(value) === 'object' && Object.keys(value).length === 0 || typeof value === 'string' && value.trim().length === 0;
};

/**
 * Deep clone to remove the reference of the object.
 * @param data
 * @returns {*}
 */
var deepClone = function (data) {
  try {
    return JSON.parse(JSON.stringify(data));
  } catch (e) {
    return data;
  }
};
var getCurrentHostName = function () {
  return window.location.hostname;
};
var isDevEnv = function () {
  var hostName = getCurrentHostName();
  return hostName.includes('localhost');
};
var isStageEnv = function () {
  var hostName = getCurrentHostName();
  return hostName.includes('qa.paypal.com');
};

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);
  var _super = _createSuper(ErrorBoundary);
  function ErrorBoundary(props) {
    var _this;
    _classCallCheck(this, ErrorBoundary);
    _this = _super.call(this, props);
    _this.state = {
      error: null,
      errorInfo: null
    };
    return _this;
  }
  _createClass(ErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, errorInfo) {
      this.setState({
        err: err,
        errorInfo: errorInfo
      });
      if (typeof this.props.cbOnError === 'function') {
        // Callback function to track errors.
        this.props.cbOnError(err, errorInfo);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.error) {
        // render any custom fallback UI
        return this.props.children;
      }
      if (this.props.suppressError) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("h1", null, 'Something went wrong in loading the widget.');
    }
  }]);
  return ErrorBoundary;
}(React.Component);
ErrorBoundary.propTypes = {
  suppressError: PropTypes.bool.isRequired,
  children: PropTypes.node,
  cbOnError: PropTypes.func.isRequired // callback function on error.
};

// //https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/onreadystatechange
var getData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url) {
    var config,
      method,
      req,
      response,
      _args = arguments;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          config = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
          method = config.method || 'GET';
          _context.prev = 2;
          req = new XMLHttpRequest();
          req.open(method, url, true);
          req.withCredentials = config.withCredentials || false;
          _context.next = 8;
          return new Promise(function (resolve, reject) {
            req.onreadystatechange = function () {
              if (req.readyState === 4) {
                if (req.status >= 200 && req.status < 300) {
                  var result = JSON.parse(req.response || req.responseText);
                  resolve(result);
                } else {
                  reject("HTTP Error: ".concat(req.status));
                }
              }
            };
            req.addEventListener('error', function (event) {
              reject(event);
            });
            req.send();
          });
        case 8:
          response = _context.sent;
          return _context.abrupt("return", {
            data: response
          });
        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](2);
          return _context.abrupt("return", Promise.reject(_context.t0));
        case 15:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 12]]);
  }));
  return function () {
    return _ref.apply(this, arguments);
  };
}();

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var defaultOptions = {
  pgrp: 'main:help:components',
  page: 'main:help:components',
  comp: 'helpComponents'
};
var analyticsObject = function () {
  try {
    return window && window.PAYPAL && window.PAYPAL.analytics;
  } catch (e) {
    return {};
  }
};

// Get FPTI otions
var getFPTIOptions = function (fptiOptions, eventType) {
  var fpti = window && window.fpti ? deepClone(window.fpti) : {};

  // clearing out error props in case they exist
  fpti.erpg = undefined;
  fpti.erfd = undefined;
  fpti.eccd = undefined;

  // Merge client passed fptiOptions with fpti object.
  fpti = _objectSpread$1(_objectSpread$1({}, fpti), fptiOptions);

  // TODO :: This logic needs to be revisited.
  // FPTI options passed through props

  if (isEmpty(fpti.page) || isEmpty(fpti.pgrp)) {
    fpti.page = defaultOptions.page;
    fpti.pgrp = defaultOptions.pgrp;
  }

  // Resetting to empty string for not to set link/pgln,phlk for ac events.
  fpti.link = '';
  fpti.pgln = '';
  fpti.pglk = '';

  // For click events
  if (fptiOptions.link) {
    fpti.link = fptiOptions.link;
    fpti.pgln = "".concat(fpti.page, "|").concat(fptiOptions.link);
    fpti.pglk = "".concat(fpti.pgrp, "|").concat(fptiOptions.link);
  }

  // Add event name to FPTI object
  fpti.event_name = '';
  if (fptiOptions.event_name) {
    fpti.event_name = fptiOptions.event_name;
  }

  // component name priority - fpti options props/analytics window object/default fallback
  if (isEmpty(fpti.comp)) {
    fpti.comp = defaultOptions.comp;
  }
  // Set event Type
  fpti.e = eventType ? eventType : 'ac'; // default activity event

  return fpti;
};

/**
 * @description
 *
 * Logs click metrics
 * @param {Object} fptiOptions
 * @property {String} options.data.page - Page name if not provided derived from the base page
 * @property {String} options.data.pgrp - Page group if not provided derived from the base page
 * e.g. var options = {data: {page:'page_name', pgrp: 'page_group_name'} }
 */
//https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/react.html#/links?_k=flh93g
var recordClickEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'cl');
    window.PAYPAL.analytics.Analytics.prototype.recordClick({
      data: options
    });
  }
};

// Error tracking
// https://github.paypal.com/pages/Tracking-R/client-side-instrumentation/#record_error
var recordErrorEvent = function (error) {
  if (window.PAYPAL && window.PAYPAL.trackJSError) {
    window.PAYPAL.trackJSError(error);
  }
};

// Record Activity Events
var recordEvent = function (fptiOptions) {
  if (analyticsObject()) {
    var options = getFPTIOptions(fptiOptions, 'ac');
    window.PAYPAL.analytics.Analytics.prototype.recordEvent(options.event_name, {
      data: options
    });
  }
};

// FPTI Prop Type
var FPTI_OBJECT = {
  page: PropTypes.string.isRequired,
  pgrp: PropTypes.string.isRequired,
  comp: PropTypes.string
};

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var PAYPAL_THEME_4 = _objectSpread(_objectSpread({}, PAYPAL_THEME), {}, {
  // HeadingText
  sysTypographyHeadingSmSize: '1.5rem',
  sysTypographyHeadingSmWeight: 400,
  sysTypographyHeadingSmLineHeight: '2rem',
  // BodyText
  sysTypographyBodyStrongSize: '1rem',
  sysTypographyBodyStrongWeight: 700,
  sysTypographyBodyStrongLineHeight: '1.3125rem',
  sysTypographyBodySize: '1rem',
  sysTypographyBodyWeight: 400,
  sysTypographyBodyLineHeight: '1.3125rem',
  // Button
  sysTypographyButtonLgSize: '1rem',
  sysTypographyButtonLgWeight: 500,
  sysTypographyButtonLgLineHeight: '1.3125rem'
});
var IPSComponent = function (props) {
  var productRefId = props.productRefId,
    pageRefId = props.pageRefId,
    fieldRefId = props.fieldRefId,
    devMode = props.devMode,
    devData = props.devData,
    fptiOptions = props.fptiOptions,
    suppressError = props.suppressError,
    appName = props.appName;
  var getMarkup = function (articleContent) {
    return {
      __html: articleContent
    };
  };
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    data = _useState2[0],
    updateData = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isSheetOpen = _useState4[0],
    setIsSheetOpen = _useState4[1];
  var _useState5 = useState({}),
    _useState6 = _slicedToArray(_useState5, 2),
    articleData = _useState6[0],
    setData = _useState6[1];
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    isInitialLoad = _useState8[0],
    isLoaded = _useState8[1];
  var _useState9 = useState(8),
    _useState10 = _slicedToArray(_useState9, 2),
    articlesLimit = _useState10[0],
    setArticlesLimit = _useState10[1];

  // Function to call the smarthelp API's and get the data
  var getMetaData = function () {
    if (devMode) {
      return updateData(devData);
    }
    var articleDataURL = '';
    if (isDevEnv()) {
      articleDataURL = "/smarthelp/api/get-ips-articles?productRefId=".concat(productRefId, "&pageRefId=").concat(pageRefId, "&fieldRefId=").concat(fieldRefId);
    } else if (isStageEnv()) {
      articleDataURL = "/smarthelp/api/get-ips-articles?productRefId=".concat(productRefId, "&pageRefId=").concat(pageRefId, "&fieldRefId=").concat(fieldRefId);
    } else {
      articleDataURL = "/smarthelp/api/get-ips-articles?productRefId=".concat(productRefId, "&pageRefId=").concat(pageRefId, "&fieldRefId=").concat(fieldRefId);
    }
    return getData(articleDataURL).then(function (response) {
      return updateData(response.data);
    }).catch(function (err) {
      var errorFptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
        page: "".concat(fptiOptions.page, "-error"),
        entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
        event_name: 'hc_ips_component_service_error_help_center'
      });
      recordEvent(errorFptiData);
      return updateData(err);
    });
  };

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(function () {
    getMetaData();
  }, []);

  // Function to handle error cases
  var handleErrorBoundaryCatch = function (error) {
    var FPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
      entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
      event_name: "hc_ips_component_boundary_".concat(appName)
    });
    recordErrorEvent(error);
    recordEvent(FPTIOptions);
  };

  // On click of view more show all the articles received from service
  var onViewMoreClick = function (event, articles) {
    event.preventDefault();
    setArticlesLimit(articles.length);

    // FPTI event - View more clicked
    var FPTIOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
      entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
      event_name: 'hc_ips_component_view_more_clicked'
    });
    recordClickEvent(FPTIOptions);
  };

  // When article sheet is closed
  var closeSheet = function () {
    setIsSheetOpen(false);
    var clickFptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
      entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
      event_name: 'hc_ips_component_article_sheet_closed_help_center',
      hpid: articleData.articleId,
      help_component_ids: articleData.ecmComponentIds
    });
    return recordClickEvent(clickFptiData);
  };

  // On article click opening the sheet view
  var openSheet = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var article,
        fptiClickEventOptions,
        clickFptiData,
        errorFptiData,
        _args = arguments;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            article = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
            setData(article);
            if (!isSheetOpen) {
              // Fire FPTI click event on click of article card
              fptiClickEventOptions = _objectSpread(_objectSpread({}, fptiOptions), {}, {
                entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
                event_name: 'hc_ips_component_article_card_clicked',
                hpid: article.articleId,
                // this should be available only for ECM articles and when value not available FPTIs will not show this key / tag
                help_component_ids: article.ecmComponentIds
              });
              recordClickEvent(fptiClickEventOptions);
            }
            _context.prev = 3;
            setIsSheetOpen(true);
            clickFptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
              entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
              event_name: 'hc_ips_component_article_sheet_displayed_help_center',
              hpid: article.articleId,
              help_component_ids: article.ecmComponentIds
            });
            return _context.abrupt("return", recordEvent(clickFptiData));
          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](3);
            // Catch block if there is any exception occured
            errorFptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
              page: "".concat(fptiOptions.page, "-error"),
              entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
              event_name: 'hc_ips_component_article_sheet_error_help_center'
            });
            return _context.abrupt("return", recordEvent(errorFptiData));
          case 13:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 9]]);
    }));
    return function () {
      return _ref.apply(this, arguments);
    };
  }();

  // Function to parse article data and pass to Horizontal scroll component

  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: PAYPAL_THEME_4
  }, function displayArticleData() {
    if (data && data.metaData) {
      var articles = data && data.articles || [];
      var headerLabel = data.metaData.labelHeader || 'Frequently asked questions';
      if (Array.isArray(articles) && articles.length) {
        var _data$metaData;
        if (isInitialLoad) {
          // page, pgrp & comp is getting from props
          var fptiData = _objectSpread(_objectSpread({}, fptiOptions), {}, {
            entry_point: "".concat(productRefId, "|").concat(pageRefId, "|").concat(fieldRefId),
            event_name: 'hc_ips_component_displayed_help_center'
          });
          recordEvent(fptiData);

          // Updating the state as the article data is loaded initially
          isLoaded(false);
        }
        return /*#__PURE__*/React.createElement(ErrorBoundary, {
          suppressError: suppressError,
          cbOnError: handleErrorBoundaryCatch
        }, /*#__PURE__*/React.createElement(Container, {
          "data-testid": "hc-ips-component-container-div",
          className: "hc-ips-component__container-div"
        }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(BodyText, {
          "data-testid": "hc-ips-component-header-text",
          className: "hc-ips-component__header-text"
        }, headerLabel))), /*#__PURE__*/React.createElement(Row, {
          "data-testid": "hc-ips-component-container-article-cards",
          className: "hc-ips-component__container-article-cards"
        }, articles.slice(0, articlesLimit).map(function (article) {
          var _article$articleId;
          return /*#__PURE__*/React.createElement(Col, {
            "data-testid": "hc-ips-component-article-cards",
            className: "hc-ips-component__article-cards",
            key: article.articleId,
            xs: 6,
            sm: 6,
            md: 3
          }, /*#__PURE__*/React.createElement(Card, {
            "data-testid": "hc-ips-component-article-card",
            className: "hc-ips-component__article-card",
            onClick: function onClick() {
              return openSheet(article);
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            "data-testid": "hc-ips-component-article-card-icon"
          }, _startsWith((_article$articleId = article.articleId) === null || _article$articleId === void 0 ? void 0 : _article$articleId.toUpperCase(), 'MED') ? /*#__PURE__*/React.createElement(PlayIcon, {
            "data-testid": "hc-ips-component-article-card-play-icon",
            className: "hc-ips-component__article-card__icon",
            size: "xl"
          }) : /*#__PURE__*/React.createElement(DocumentIcon, {
            "data-testid": "hc-ips-component-article-card-document-icon",
            className: "hc-ips-component__article-card__icon",
            size: "xl"
          })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(BodyText, {
            "data-testid": "hc-ips-component-article-card-body-text",
            className: "hc-ips-component__article-card__body-text",
            size: "sm",
            strong: true
          }, article.articleTitle)))));
        })), articles.length > articlesLimit ? /*#__PURE__*/React.createElement("div", {
          "data-testid": "hc-ips-component-view-more-articles",
          className: "hc-ips-component__view-more-articles"
        }, /*#__PURE__*/React.createElement(Button, {
          onClick: function onClick(event) {
            return onViewMoreClick(event, articles);
          },
          tertiary: true
        }, ((_data$metaData = data.metaData) === null || _data$metaData === void 0 ? void 0 : _data$metaData.labelViewMore) || 'View more')) : null), /*#__PURE__*/React.createElement("div", {
          className: "hc-ips-component__title-card__cs-help-ips"
        }, /*#__PURE__*/React.createElement(Sheet, {
          isOpen: isSheetOpen,
          onClose: closeSheet,
          className: "hc-ips-component__title-card__cs-help-ips-article",
          skipFormFocus: true,
          hideTitle: true
        }, /*#__PURE__*/React.createElement("div", {
          className: "hc-ips-component__title-card__cs-help-ips-article__details"
        }, /*#__PURE__*/React.createElement(HeadingText, {
          size: "sm",
          className: "hc-ips-component__title-card__cs-help-ips-article__details__title"
        }, articleData.articleTitle), /*#__PURE__*/React.createElement(BodyText, {
          className: "hc-ips-component__title-card__cs-help-ips-article__details__content",
          dangerouslySetInnerHTML: getMarkup(articleData.articleContent) // eslint-disable-line react/no-danger
        })))));
      }
      var errorLabel = data.metaData.labelError || '';
      var helpCenterLabel = data.metaData.labelHelpCenter || '';
      if (errorLabel && helpCenterLabel) {
        return /*#__PURE__*/React.createElement("div", {
          className: "hc-ips-component__error"
        }, /*#__PURE__*/React.createElement(BodyText, {
          className: "hc-ips-component__error__header-text"
        }, headerLabel), /*#__PURE__*/React.createElement("div", {
          className: "hc-ips-component__error__div"
        }, /*#__PURE__*/React.createElement(BodyText, {
          className: "hc-ips-component__error__div__label"
        }, errorLabel), /*#__PURE__*/React.createElement(Link, {
          className: "hc-ips-component__error__div__help_center_link",
          href: 'https://www.paypal.com/smarthelp/home'
        }, helpCenterLabel)));
      }
    }
    return null;
  }());
};
IPSComponent.propTypes = {
  productRefId: PropTypes.string.isRequired,
  pageRefId: PropTypes.string.isRequired,
  fieldRefId: PropTypes.string.isRequired,
  viewMoreLink: PropTypes.string,
  devMode: PropTypes.bool,
  // Development Purpose only
  devData: PropTypes.shape({}),
  // Development Purpose Only
  suppressError: PropTypes.bool,
  fptiOptions: PropTypes.shape(FPTI_OBJECT).isRequired,
  appName: PropTypes.string.isRequired
};
IPSComponent.defaultProps = {
  productRefId: 'CONSUMER',
  pageRefId: 'Summary',
  fieldRefId: 'TAX_CENTER',
  suppressError: true,
  appName: '',
  fptiOptions: {
    page: 'hc-ips-component',
    pgrp: 'hc-ips-component'
  }
};

export { IPSComponent };
